// extracted by mini-css-extract-plugin
module.exports = {"form":"ContactForm_form__SLOQm","select":"ContactForm_select__G3QLB","submitButton":"ContactForm_submitButton__1PZT4"};